<template>
  <div class="auth login">
    <form class="box" @submit="submitForm">
      <h1 class="box__title">{{ $t('auth.authheading')}}</h1>
      <p class="box__intro">{{ $t('auth.authintro')}}</p>
      <hr/>
      <div>
        <div class="form-group">
          <label for="email">{{ $t('auth.email')}}</label>
          <input type="text" v-bind:placeholder="$t('auth.emailplaceholderlogin')" class="form-control" id="email" aria-describedby="emailHelp" v-model="email" required>
          <span class="help-block" v-if="error.email">{{emailMesage}}</span>
        </div>

        <div class="form-group">
          <label for="password">{{ $t('auth.password')}}</label>
          <input type="password" v-bind:placeholder="$t('auth.passwordplaceholderlogin')" class="form-control" id="password" aria-describedby="passwordHelp" v-model="password" required>
          <span class="help-block" v-if="error.password">{{passwordMesage}}</span>
          <div class="login__passwordmessage form-group__desc">
            <router-link to="/forget">{{ $t('auth.resetpasswordlink')}}</router-link>
          </div>
        </div>
      </div>

      <div>
        <div class="action d-flex justify-content-center">
          <button v-bind:disabled="!formValid" type="submit" class="btn btn--primary">
            Login
          </button>
        </div>
      </div>
      <hr/>
      <div class="login__registermessage">
        <p>Not registered yet?<br/>
          <router-link to="/register">{{ $t('auth.signup')}}</router-link>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixins from '../mixins'

export default {
  name: 'Login',

  mixins: [mixins],

  computed: {
    formValid () {
      return this.email !== '' && this.password !== ''
    }
  },

  data () {
    return {
      email: '',
      password: '',
      error: {
        email: false,
        emailMessage: '',
        password: false,
        passwordMessage: ''
      }
    }
  },

  methods: {

    ...mapActions('user', ['login']),

    submitForm (e) {
      e.preventDefault()

      if (this.formValid) {
        const payload = {
          email: this.email,
          password: this.password
        }

        this.login(payload).then(() => {
          this.$router.push({
            name: 'dashboard'
          })
        }).catch(() => {})
      }
    }
  }
}
</script>
